<app-header></app-header>

<div id="carouselExampleIndicators" class="carousel slide main-carousel" data-bs-ride="carousel" >
  <ol class="carousel-indicators" style="z-index: 3;">
    <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"></li>
    <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></li>
    <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"></li>
    <!-- <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3"></li> -->
  </ol>
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="assets/Homepage/slider1.jpg" class="d-block w-100 carousel-image" alt="Welcome">
      <div class="overlay-shape">
        <div class="text-wrapper">
          <p class="shape_fnt">Welcome to River Valley School</p>
          <p class="para_fnt">
            Get Professional education and reliable consultation by our team of certified teachers and instructors.
          </p>
        </div>
      </div>
    </div>
    
    <div class="carousel-item">
      <img src="assets/Homepage/slider2.jpg" class="d-block w-100 carousel-image" alt="Teachers">
      <div class="overlay-shape">
        <div class="text-wrapper">
          <p class="shape_fnt">Certified Teachers</p>
          <p class="para_fnt">Get Professional education and reliable consultation by our team of certified teachers and instructors.</p>
        </div>
      </div>
    </div>

    <div class="carousel-item">
      <img src="assets/Homepage/book&lib.jpeg" class="d-block w-100 carousel-image" alt="Library">
      <div class="overlay-shape">
        <div class="text-wrapper">
          <p class="shape_fnt">Books and Library</p>
          <p class="para_fnt">This school has one of the world's busiest public library systems with over 10 million books, movies and other items to borrow.</p>
        </div>
      </div>
    </div>

    <!-- <div class="carousel-item">
      <img src="assets/Homepage/01 (6).png" class="d-block w-100 carousel-image" alt="...">
    </div> -->

  </div>
  <a class="carousel-control-prev" style="z-index: 4;" href="#carouselExampleIndicators" role="button" data-bs-slide="prev">
    <span class="carousel-control-prev-icon rounded" style="border: 1px solid white; background-color: rgb(255, 255, 255,0.5);" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </a>
  <a class="carousel-control-next" style="z-index: 4;" href="#carouselExampleIndicators" role="button" data-bs-slide="next">
    <span class="carousel-control-next-icon rounded" aria-hidden="true" style="border: 1px solid white; background-color: rgb(255, 255, 255,0.5);"></span>
    <span class="visually-hidden">Next</span>
  </a>
</div>

<div class="container-fluid">
  <div class="section-heading">
    <u>&nbsp;&nbsp;About</u>&nbsp;<u>Us&nbsp;&nbsp;</u>
  </div>
  <div class="row align-items-center message-row">
    <div class="col-lg-5 col-12 order-1 text-center">
      <div class="image-shadow-container" style="--image-url: url('/assets/Homepage/slider1.jpg');">
        <img src="assets/Homepage/slider1.jpg" alt="school" class="main-image">
      </div>
    </div>
    <!-- <div class="col-lg-6 col-sm-12 col-md-6 position-relative" style="min-height:400px;overflow: hidden; ">
      <img src="assets/Homepage/01 (2).png" width="60%" class="back-img" >
        <img class="front-img " width="60%" src="assets/Homepage/01 (2).png"  alt="">
    </div> -->
    <div class="col-lg-7 col-12 order-2">
      <div class="message-text" style="text-align: justify;">
        Education is a life – long journey and the School realizes the importance of a good start. It is here that the foundation for the love of learning is laid and strengthened. The classrooms, laboratories; activity rooms etc. are designed for greater efficiency, and to protect children from air and noise pollution. Our pupil are encouraged and guided to develop their analytical and problem solving skills.
        Special tutorial/remedial teaching both during teaching and after school hours are arranged according to the need of each child. The students are engaged in constructive activities which stimulate them intellectually. The different disciplines taught are English, Hindi, Math, E.V.S, General Knowledge, Computers, etc. These widen their perspective to deal with real life situations effectively. A wide range of co-curricular activities are offered to the students to ensure their wholesome all-round development. At each grade level, students are challenged academically and personally to learn and grow. From the lab to the stage, our faculty and staff guide students as they gain understanding and proficiency across all disciplines. 
        <span *ngIf="!showAboutFull"></span>
        <span *ngIf="showAboutFull">
          Our academic program is designed to teach students the knowledge, skills, and attitudes that will best prepare them for success in a global society. B.E.S. students are supported by faculty and staff with outstanding experience and credentials in their fields, as well as a passion for educating young people. 
          An ongoing professional development program and evaluation system supports teachers at all stages of their careers by supporting their growth in areas such as pedagogy (the study of how best to teach), inclusion and equity, technology, and discipline-specific knowledge. Special tutorial/remedial teaching both during teaching and after school hours are arranged according to the need of each child. The students are engaged in constructive activities which stimulate them intellectually. The different disciplines taught are English, Hindi, Math, E.V.S, General Knowledge, Computers, etc. These widen their perspective to deal with real life situations effectively. A wide range of co-curricular activities are offered to the students to ensure their wholesome all-round development. We strive to provide an equitable learning environment for all students, and we believe every student should have an equal opportunity to participate in and contribute to the life of the school.
        </span>

        <a (click)="showAboutFull = !showAboutFull" class="read-more-link">
          {{ showAboutFull ? '(Read Less)' : '...(Read More)' }}
        </a>
      </div>
    </div>
  </div>
</div>


<div class="container-fluid behind">
  <div class="section-heading">
    <u>&nbsp;&nbsp;People</u>&nbsp;<u>Behind the Vision&nbsp;&nbsp;</u>
  </div>

  <!-- Chairman Section -->
  <div class="row align-items-center message-row" id="Chairman">
    <div class="col-lg-7 col-12 order-1"> 
      <div class="message-title">Chairman's Message</div> 
      <div class="message-text">
        Dear Parents and Students, <br />
        A person's life shines and flourishes only through education. It is the foundation of a happy and meaningful existence. Education leads us to economic stability, social development, and scientific progress — not just for the individual, but for the nation and humanity at large.<br />
        Education makes us creative and helps shape multi-dimensional personalities within society. Since ancient times, schools have been an indispensable part of the social fabric. There has always been a symbiotic relationship between schools and society — society supports schools, and in return, schools nurture and uplift society. Unfortunately, in recent times, this strong bond has weakened.<br />
        In Bihar, institutions like Nalanda University once drew scholars from across the globe, reminding us of our rich educational legacy. It is a well-established fact that the true parameter of a society’s development is the quality of education it provides. We cannot imagine our existence without education. It is through education that we create complete human beings.<br />
        When we face challenges, we may feel weak for a moment — but within us exists a restlessness, a desire to act.

        <span *ngIf="!showChairmanMessage"></span>
        <span *ngIf="showChairmanMessage">
          <br />
          This feeling of unrest — the urge to contribute to society — should exist in every individual. And it is education that awakens this spirit within us.<br />
          For this noble cause, Progressive Central High School, Patsa, located in the rural heart of Mithilanchal, has been striving for many years to provide quality education to the talented youth of the region. It has helped students realize their highest dreams and aspirations.<br />
          Our school, located in Hasanpur, Samastipur, truly lives up to its name by continuously pushing for the progress of this area. A team of visionary, energetic, and efficient educators and staff — along with a proactive management body — are working tirelessly to adapt to modern teaching methods and pedagogy. We aim to cultivate scientific thinking and a rational approach in our students.<br />
          As a result, our alumni have proven themselves across diverse fields — whether in science and technology, arts and culture, sports, management, or leadership. They shine like stars at every level of professional life.<br />
          We are deeply thankful to our dedicated teachers, hardworking staff, and the supportive community we belong to. Our teachers are highly educated, enthusiastic, and committed to their profession.<br />
          The school is well-equipped with modern educational tools — including a rich library, fully functional science labs for Biology, Physics, Chemistry, and Mathematics, as well as a Music room. Our computer lab is another major asset that caters to students' everyday learning needs.<br />
          We firmly believe in both scholastic and co-scholastic development to nurture complete individuals. Discipline, in our view, is developed through impression and experience, and so we walk alongside our students in the journey of learning.<br />
          As a co-educational institution, we ensure equal opportunities for both boys and girls, working without any discrimination of caste, creed, or religion.<br />
          We remain hopeful and committed to becoming even more valuable to the society we proudly serve.
        </span>

        <a (click)="showChairmanMessage = !showChairmanMessage" class="read-more-link">
          {{ showChairmanMessage ? '(Read Less)' : '...(Read More)' }}
        </a>
        <!-- <div class="mt-2">Warm Regards,</div> -->
      </div>
      <!-- <div style="padding-left: 5%;">
        <img src="assets/sign_dir.png" alt="">
      </div> -->
    </div>
    <div class="col-lg-5 col-12 order-2 text-center">
      <img class="profile-img" src="assets/Homepage/director.jpg" alt="Chairman" />
      <div class="person-name">Ramnandan Singh <br />(Chairman)</div>
    </div>
  </div>


  <!-- Director Section -->
  <div class="row align-items-center message-row" id="director">
    <div class="col-lg-7 col-12 order-lg-2 order-1">
      <div class="message-title">Director's Message</div>
      <div class="message-text">
        Dear Parents and Students, <br />
        Education is not merely a tool for academic excellence but a powerful means of transforming lives. At Progressive Central High School, Patsa, we firmly believe in nurturing the innate talents of every child and instilling in them a lifelong passion for learning and growth.
        Our commitment has always been to create a nurturing, inclusive, and progressive learning environment where students feel inspired and empowered to shape their own future. In today’s rapidly changing world, we must prepare our children not only with knowledge, but with values, adaptability, and a sense of responsibility toward society.
        <span *ngIf="!showDirectorMessage"></span>
        <span *ngIf="showDirectorMessage">
          <br />
          We focus on holistic development — balancing academics with co-curricular and life skill education. Our dedicated team of teachers, well-equipped infrastructure, and a vision-driven management ensure that every student receives the guidance and support they need to thrive.
          <br />
          Let us continue this journey together, committed to excellence, compassion, and innovation — building a generation ready to contribute meaningfully to the nation and the world.
          <br />
          Thank you for placing your trust in us.
        </span>
        <a (click)="showDirectorMessage = !showDirectorMessage" class="read-more-link">
          {{ showDirectorMessage ? '(Read Less)' : '...(Read More)' }}
        </a>
      </div>
      <!-- Optional signature -->
      <!-- <div style="padding-left: 5%;">
        <img src="assets/sign_dir.png" alt="Director Signature">
      </div> -->
    </div>
    <div class="col-lg-5 col-12 order-lg-1 order-2 text-center">
      <img class="profile-img" src="assets/Homepage/director-vs.jpg" alt="Director" />
      <div class="person-name">Veena singh <br />(Director)</div>
    </div>
  </div>


  <!-- Principal Section -->
  <div class="row align-items-center message-row" id="principal">
    <div class="col-lg-5 col-12 order-2 text-center">
      <img class="profile-img" src="assets/Homepage/principal-ap.jpg" alt="Principal" />
      <div class="person-name">Ananya Pal <br />(Principal)</div>
    </div>
    <div class="col-lg-7 col-12 order-1">
      <div class="message-title">Principal's Message</div>
      <div class="message-text">
        Dear Parents and Students, <br />
        Education is the process of acquiring knowledge, skills, values, and good habits. The purpose of education is to teach students not only “how to make a living” but also “how to live life meaningfully.”<br />
        A teacher should cultivate curiosity in students so they continue learning throughout their lives. In my opinion, it is the right of a child to be wrong — for they learn by making mistakes.<br />
        At River Valley School, all our efforts are directed toward teaching in a way that makes learning enjoyable and engaging. Over the years, the school has demonstrated its vision through excellent board results, achievements in games and sports, and vibrant participation in co-curricular activities.
        
        <span *ngIf="!showPrincipalMessage"></span>
        <span *ngIf="showPrincipalMessage">
          <br />
          The school provides and promotes ample opportunities to foster qualities such as honesty, responsible citizenship, leadership, and tolerance in our students.<br />
          I wish grand success to all our students as they continue to progress by leaps and bounds in life.
        </span>

        <a (click)="showPrincipalMessage = !showPrincipalMessage" class="read-more-link">
          {{ showPrincipalMessage ? '(Read Less)' : '...(Read More)' }}
        </a>
        <!-- <div class="mt-2">Warm Regards,</div> -->
      </div>
      <!-- <div style="padding-left: 5%;">
        <img src="assets/sign_dir.png" alt="">
      </div> -->
    </div>
  </div>
</div>

<div class="container-fluid px-4 text-center school-events">
  <div class="section-heading">
    <u>&nbsp;&nbsp;School</u>&nbsp;<u>Events&nbsp;&nbsp;</u>
  </div>
  <div class="events-grid">
    <div class="event-card pointer fade-in" [routerLink]="['/gallery']">
      <div class="image-container">
        <img src="../../../assets/Sports/sports.jpg" alt="Sports" />
        <div class="image-text"><p>Sports</p></div>
      </div>
    </div>

    <div class="event-card pointer fade-in" [routerLink]="['/gallery']">
      <div class="image-container">
        <img src="../../../assets/Cultural/craft.jpg" alt="Craft" />
        <div class="image-text"><p>Craft</p></div>
      </div>
    </div>

    <div class="event-card pointer fade-in" [routerLink]="['/gallery']">
      <div class="image-container">
        <img src="../../../assets/celebration/festival.jpg" alt="Festival" />
        <div class="image-text"><p>Festival</p></div>
      </div>
    </div>
  </div>
</div>


<app-home-faq></app-home-faq>

<div class="container-fluid text-white" style="background-color: #0A156F;">
  <div class="row">
    <div class="section-heading">
      <u>&nbsp;&nbsp;Contact</u>&nbsp;<u>Us&nbsp;&nbsp;</u>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 ps-5 my-2 align-items-center">
         <div class="d-flex my-4 ms-5">
           <div class="round"><mat-icon class="text-center align-items-center"> email</mat-icon></div>
           <div class="d-flex flex-column ps-2">
            <span>Email</span>
            <span>rvsbgs08@gmail.com</span>
           </div>
         </div>

         <div class="d-flex my-5 ms-5 align-items-center">
          <div class="round"><mat-icon class="text-center align-items-center"> phone</mat-icon></div>
          <div class="d-flex flex-column ps-2">
             <span>Phone</span>
             <span>7546997711/22</span>
             <!-- <span>+91-9431022739</span> -->
          </div>
        </div>

        <div class="d-flex my-5 ms-5 align-items-center">
          <div class="round"><mat-icon class="text-center align-items-center"> place</mat-icon></div>
          <div class="d-flex flex-column ps-2">
             <span>Address</span>
             <span>River Valley School</span>
              <span>Anand Vihar , Institutional Area, SH-55 , Begusarai -851218</span> 
          </div>
        </div>
    </div>

    <div class="col-lg-8 col-md-6 col-sm-12 px-4 my-4">
      <div class="row">
        <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2" > 
          <label for="inputField"><b>Name</b> </label>
          <input type="text" id="inputField" name="inputField" class="white-border">
        </div>

        <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2"> 
          <label for="inputField"><b>Email</b> </label>
          <input type="text" id="email" name="inputField" class="white-border">
        </div>
      </div>

      <div class="row mt-2">
        <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2" > 
          <label for="inputField"><b>Phone</b> </label>
          <input type="text" id="phone" name="inputField" class="white-border">
        </div>

        <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-6 px-2"> 
          <label for="inputField"><b>Subject</b> </label>
          <input type="text" id="subject" name="inputField" class="white-border">
        </div>
      </div>

      <div class="mt-2 row">
        <div class="d-flex flex-column col-lg-12 col-md-6 col-sm-6 px-2"> 
          <label for="inputField"><b>Description</b> </label>
          <textarea id="messageField" name="messageField" class="white-border1" rows="4"></textarea>
        </div>
      </div>
     
      <div class="mt-4 text-center">
        <button mat-button style="background-color: #F09959;">Send Message</button>
      </div>

      
    </div>
  </div>
</div>


<button mat-flat-button color="primary" class="enquiry-button">
  <mat-icon class="icon">question_answer</mat-icon>
  Enquiry
</button>


<app-footer></app-footer>
